import React from "react";
import { Form } from "antd";
import AddressInput from "../../Inputs/AddressInput";

const RouteEndLocationForm = ({ driverId, address, lat, lng, onSubmit }) => {
  const [form] = Form.useForm();

  const handleOnFinish = async values => {
    const params = {
      endAddress: values["endAddress"].address,
      endLat: values["endAddress"].latLng.lat,
      endLng: values["endAddress"].latLng.lng,
    };
    onSubmit({ driver: driverId, ...params });
  };

  const handleOnChangeAddress = endAddress => {
    form.setFieldsValue({ endAddress });
    form.submit();
  };

  return (
    <Form
      form={form}
      initialValues={{
        endAddress: {
          address: address,
          latLng: { lat, lng },
        },
      }}
      onFinish={handleOnFinish}>
      <Form.Item name="endAddress" rules={[{ required: true }]} style={{ margin: 0 }}>
        <AddressInput onSelect={handleOnChangeAddress} />
      </Form.Item>
    </Form>
  );
};

export default RouteEndLocationForm;
